document.addEventListener('DOMContentLoaded', function () {
    initInfobar();
});

function initInfobar() {
    const infobar = jQuery('[data-infobar]');
    const infobarClose = jQuery('[data-infobar-close]');

    if(infobar && infobarClose) {
        infobar.addClass('active');

        infobarClose.on('click', function () {
            infobar.removeClass('active');
        });
    }
}